import { FC } from 'react'

import CommercialProvider from './CommercialProvider'
import ConciliationProvider from './conciliationProvider'
import ParametersProvider from './ParametersProvider'
import ReportProvider from './ReportProvider'
import StoreProvider from './storeProvide'
const BudgetProvider: FC = ({ children }) => {
  return (
    <ParametersProvider>
      <StoreProvider>
        <ConciliationProvider>
          <CommercialProvider>
            <ReportProvider>{children}</ReportProvider>
          </CommercialProvider>
        </ConciliationProvider>
      </StoreProvider>
    </ParametersProvider>
  )
}

export default BudgetProvider
